import styled from "styled-components";
import React, { useState } from "react";

// ********** Styles ********
const RegistrationBannerContainer = styled.div`
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: #e9d1aa;
  color: black;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

const BannerMessage = styled.p`
  margin: 0;
  font-size: 14px;
`;

const CompleteButton = styled.button`
  background-color: white;
  color: #ff9800;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: red;
  margin-left: 15px;
  cursor: pointer;
  font-size: 25px;
`;

// ******************************

interface RegistrationBannerProps {
  onCompleteClick?: () => void;
  onClose?: () => void;
}

const RegistrationBanner: React.FC<RegistrationBannerProps> = ({
  onCompleteClick,
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  return (
    <RegistrationBannerContainer>
      <BannerMessage>
        Your PCN registration is incomplete. Please complete it to access all
        features.
      </BannerMessage>
      <div>
        {onCompleteClick && (
          <>
            <CompleteButton onClick={onCompleteClick}>
              Complete Registration
            </CompleteButton>
          </>
        )}

        {/* {onClose && ( */}
        <CloseButton onClick={handleClose}>&times;</CloseButton>
        {/* )} */}
      </div>
    </RegistrationBannerContainer>
  );
};

export default RegistrationBanner;
